/* ALGEA — lens recommender, visual decision layer.

   The recommender engine (algea-lens-rx.js) is generated and minified; it owns
   every rule about which lens is offered and at what price. This file never
   changes that logic. It only READS what the engine renders and adds visual
   cues that make the choice easier to see:

     1. a four-step progress bar in the drawer head
     2. a lens-zone diagram on each vision tile (where you see sharp)
     3. on the result cards: the same diagram, the lens index,
        and the price difference against the first (most economical) option
     4. a summary of the customer's answers above the results

   Everything here is derived from the DOM the engine already produced, so a
   catalogue rebuild can never make this layer show a different price. */
(function () {
  "use strict";
  var AT = function (s) { return window.AlgeaT ? window.AlgeaT(s) : s; };

  var STEPS = [
    { key: "shikimi", label: AT("Shikimi"), match: ["shikimi", "diell"] },
    { key: "recete", label: AT("Receta"), match: ["recete"] },
    { key: "nevojat", label: AT("Nevojat"), match: ["nevojat"] },
    { key: "result", label: AT("Opsionet"), match: ["result", "ngjyra"] }
  ];

  /* Lens-zone diagrams. Each shows, on one lens outline, which part of the
     lens is focused for which distance — the thing the customer is choosing. */
  var LENS = "M6 20c0-9 7-15 26-15s26 6 26 15-7 15-26 15S6 29 6 20z";
  var clipPrefix = "agvc-" + Math.random().toString(36).slice(2) + "-";
  var clipSerial = 0;
  function svg(inner, title) {
    return '<svg class="agv-lens" viewBox="0 0 64 40" role="img" aria-label="' + title + '">' +
      '<defs><clipPath id="__AGV_CLIP__"><path d="' + LENS + '"/></clipPath></defs>' +
      '<g clip-path="url(#__AGV_CLIP__)">' + inner + "</g>" +
      '<path d="' + LENS + '" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>';
  }
  var DIAGRAM = {
    mono: svg('<rect width="64" height="40" class="agv-z agv-z--far"/>', AT("Një distancë në të gjithë lenten")),
    prog: svg(
      '<rect width="64" height="17" class="agv-z agv-z--far"/>' +
      '<path d="M26 17h12l-3 9h-6z" class="agv-z agv-z--mid"/>' +
      '<path d="M29 26h6l5 14H24z" class="agv-z agv-z--near"/>',
      AT("Larg lart, mes në qendër, afër poshtë")),
    bifo: svg(
      '<rect width="64" height="40" class="agv-z agv-z--far"/>' +
      '<path d="M20 27h24a12 8 0 0 1-24 0z" class="agv-z agv-z--near"/>',
      AT("Larg sipër, segment leximi poshtë")),
    office: svg(
      '<rect width="64" height="22" class="agv-z agv-z--mid"/>' +
      '<rect y="22" width="64" height="18" class="agv-z agv-z--near"/>',
      AT("Ekran dhe tavolinë — distanca të afërta")),
    sun: svg('<rect width="64" height="40" class="agv-z agv-z--sun"/>', AT("Lente me ngjyrë për diell"))
  };

  function diagram(key) {
    return (DIAGRAM[key] || DIAGRAM.mono).replace(/__AGV_CLIP__/g, clipPrefix + (++clipSerial));
  }

  var LEGEND =
    '<div class="agv-legend" aria-hidden="true">' +
    '<span><i class="agv-z--far"></i>' + AT("Larg") + '</span>' +
    '<span><i class="agv-z--mid"></i>' + AT("Mes") + '</span>' +
    '<span><i class="agv-z--near"></i>' + AT("Afër") + '</span></div>';

  function num(text) {
    var m = String(text || "").replace(/[\s,.](?=\d{3}\b)/g, "").match(/(\d+(?:[.,]\d+)?)/);
    return m ? parseFloat(m[1].replace(",", ".")) : null;
  }
  function money(n, cur) {
    return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " " + cur;
  }
  function currencyOf(text) {
    var m = String(text || "").match(/[A-Z]{3}/);
    return m ? m[0] : "ALL";
  }
  function visibleStep(drawer) {
    var s = drawer.querySelector("[data-rx-step]:not([hidden])");
    return s ? s.getAttribute("data-rx-step") : null;
  }
  function currentVision(drawer) {
    var t = drawer.querySelector('[data-rx-vision][aria-checked="true"]');
    return t ? t.getAttribute("data-rx-vision") : null;
  }

  /* 1 — progress bar */
  function buildStepper(drawer) {
    var head = drawer.querySelector(".ag-rx__head");
    if (!head || head.parentNode.querySelector(".agv-steps")) return;
    var ol = document.createElement("ol");
    ol.className = "agv-steps";
    ol.setAttribute("aria-label", "Hapat");
    STEPS.forEach(function (s, i) {
      var li = document.createElement("li");
      li.setAttribute("data-agv-step", s.key);
      li.innerHTML = "<b>" + (i + 1) + "</b><span>" + s.label + "</span>";
      ol.appendChild(li);
    });
    head.insertAdjacentElement("afterend", ol);
  }
  function syncStepper(drawer) {
    var cur = visibleStep(drawer);
    var at = -1;
    STEPS.forEach(function (s, i) { if (s.match.indexOf(cur) !== -1) at = i; });
    drawer.querySelectorAll("[data-agv-step]").forEach(function (li, i) {
      li.classList.toggle("is-done", i < at);
      li.classList.toggle("is-current", i === at);
      if (i === at) li.setAttribute("aria-current", "step"); else li.removeAttribute("aria-current");
    });
  }

  /* 2 — diagrams on the vision tiles */
  function decorateTiles(drawer) {
    drawer.querySelectorAll("[data-rx-vision]").forEach(function (tile) {
      if (tile.querySelector(".agv-lens")) return;
      var d = DIAGRAM[tile.getAttribute("data-rx-vision")];
      if (!d) return;
      var wrap = document.createElement("span");
      wrap.className = "agv-tile-lens";
      wrap.setAttribute("aria-hidden", "true");
      wrap.innerHTML = diagram(tile.getAttribute("data-rx-vision"));
      tile.insertBefore(wrap, tile.firstChild);
    });
    var tiles = drawer.querySelector(".ag-rx__tiles");
    if (tiles && !drawer.querySelector(".agv-legend")) tiles.insertAdjacentHTML("afterend", LEGEND);
  }

  /* 3 — result cards */
  function decorateResults(drawer) {
    var box = drawer.querySelector("[data-rx-results]");
    if (!box) return;
    var cards = Array.prototype.slice.call(box.querySelectorAll(".ag-rx-card"));
    if (!cards.length) return;
    var sig = cards.map(function (c) { return c.getAttribute("data-pick"); }).join("|") + "#" + cards.filter(function (c) { return !c.querySelector(".agv-card"); }).length;
    if (box.getAttribute("data-agv-sig") === sig) return;

    var prices = cards.map(function (c) { return num((c.querySelector(".ag-opt__price") || {}).textContent); });
    var cur = currencyOf((cards[0].querySelector(".ag-opt__price") || {}).textContent);
    var base = prices[0];
    var vision = currentVision(drawer) || "mono";

    cards.forEach(function (card, i) {
      card.querySelectorAll(".agv-card").forEach(function (n) { n.remove(); });
      var bodyEl = card.querySelector(".ag-opt__body");
      if (!bodyEl) return;

      var specEl = card.querySelector(".ag-opt__spec");
      var idxMatch = specEl && specEl.textContent.match(/(1[.,]\d{1,2})/);
      var idx = idxMatch ? idxMatch[1].replace(",", ".") : null;

      var html = '<span class="agv-card">';
      html += '<span class="agv-card__lens" aria-hidden="true">' + diagram(vision) + "</span>";
      html += '<span class="agv-card__facts">';
      if (i === 0) {
        html += '<span class="agv-chip">' + AT("Opsioni i parë") + '</span>';
      } else if (base != null && prices[i] != null && prices[i] > base) {
        html += '<span class="agv-chip">+' + money(prices[i] - base, cur) + AT(" nga opsioni 1") + "</span>";
      }
      if (idx) html += '<span class="agv-thin"><span class="agv-thin__lbl">' + AT("Indeksi ") + idx + "</span></span>";
      html += "</span></span>";
      bodyEl.insertAdjacentHTML("afterbegin", html);
    });

    box.setAttribute("data-agv-sig", cards.map(function (c) { return c.getAttribute("data-pick"); }).join("|") + "#0");
    renderSummary(drawer);
  }

  /* 4 — answers summary */
  function renderSummary(drawer) {
    var step = drawer.querySelector('[data-rx-step="result"]');
    if (!step) return;
    var parts = [];
    var v = drawer.querySelector('[data-rx-vision][aria-checked="true"]');
    if (v) parts.push(v.getAttribute("data-rx-label"));
    var sc = drawer.querySelector('[data-rx-scope][aria-checked="true"]');
    if (sc) parts.push(sc.getAttribute("data-rx-scope-label"));
    var pol = drawer.querySelector('[data-rx-pol][aria-checked="true"]');
    if (pol) parts.push(pol.getAttribute("data-rx-pol-label"));
    var md = drawer.querySelector('[data-rx-mode][aria-checked="true"]');
    if (md) parts.push(md.getAttribute("data-rx-label"));
    drawer.querySelectorAll('[data-rx-need][aria-pressed="true"], [data-rx-sunuse][aria-pressed="true"]').forEach(function (n) {
      parts.push(n.textContent.trim());
    });
    var el = step.querySelector(".agv-summary");
    if (!el) {
      el = document.createElement("div");
      el.className = "agv-summary";
      step.insertBefore(el, step.firstChild);
    }
    el.innerHTML = '<span class="agv-summary__lbl">Zgjedhjet tuaja</span>' +
      parts.filter(Boolean).map(function (p) { return '<span class="agv-summary__chip">' + p.replace(/</g, "&lt;") + "</span>"; }).join("");
  }

  function refresh(drawer) {
    syncStepper(drawer);
    decorateResults(drawer);
  }

  function init(drawer) {
    if (drawer.getAttribute("data-agv") === "2") return;
    drawer.setAttribute("data-agv", "2");
    buildStepper(drawer);
    decorateTiles(drawer);
    syncStepper(drawer);
    /* Synchronous refresh on every relevant mutation. No rAF or timer: rAF is
       paused in background tabs and a stuck flag would freeze the layer. The
       signature check in decorateResults stops our own writes looping. */
    new MutationObserver(function () { refresh(drawer); })
      .observe(drawer.querySelector(".ag-rx__body") || drawer, {
        subtree: true, childList: true, attributes: true, attributeFilter: ["hidden"]
      });
    drawer.addEventListener("click", function () { setTimeout(function () { refresh(drawer); }, 0); });
  }

  function boot() { document.querySelectorAll("[data-rx-drawer]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", boot);
})();
